import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevanseatertempotravellernighojpotholes() {



const cardData =
{
  keyword: '17 Seater Tempo Traveller Nighoj Potholes Bus Trip',
  heading: 'Sanavi Travels: 17 Seater Tempo Traveller Nighoj Potholes Bus Trip',
  headingDescription: 'Sanavi Travels offers a well-planned 17 Seater Tempo Traveller service for Nighoj Potholes, ideal for families, groups, corporate teams, students, and nature lovers who want a safe, comfortable, and organized journey to one of Maharashtra’s most unique geological wonders.',

  top: 'Top Places & Experiences at Nighoj Potholes with Tempo Traveller',

  topPlaces: [
    {
      title: 'Nighoj Potholes – Natural Geological Wonder',
      description: 'Nighoj Potholes are among the largest natural potholes in Asia, carved over thousands of years by the Kukadi River. Visiting this rare geological site in a 17 seater Tempo Traveller allows groups to travel together comfortably from Pune and nearby regions without worrying about rough roads, parking challenges, or vehicle coordination. The Tempo Traveller’s high ground clearance and stable suspension are especially useful near village roads leading to the site. For families, students, and nature enthusiasts, the journey becomes educational and enjoyable, with enough space to relax, discuss geology, and prepare for exploration. Group travel ensures safety near rocky areas and helps maintain schedules for guided explanations and photography sessions.'
    },
    {
      title: 'Kukadi River & Surrounding Rocky Formations',
      description: 'The Kukadi River flows through Nighoj and is responsible for shaping the dramatic rock formations and potholes seen today. Traveling together by Tempo Traveller enables visitors to carry essentials like water, snacks, first-aid kits, and photography equipment safely. The shared travel experience enhances learning as guides explain river erosion, seasonal changes, and local ecology during the journey. The vehicle also serves as a comfortable resting point between walking sessions, especially for elders and children.'
    },
    {
      title: 'Village Life & Rural Maharashtra Experience',
      description: 'Nighoj village offers a glimpse into authentic rural Maharashtra, with simple homes, farmlands, and traditional lifestyles. Group travel by Tempo Traveller supports respectful tourism by reducing multiple vehicle movement and allowing planned stops. Visitors can interact with locals, learn about village history, and understand how the potholes influence regional identity. Traveling together also helps manage time efficiently while exploring both natural and cultural aspects of the area.'
    },
    {
      title: 'Educational & Student Study Tours',
      description: 'Nighoj Potholes are a popular destination for geology and geography study tours. A 17 seater Tempo Traveller provides a controlled, safe, and supervised environment for students. Teachers can manage attendance, ensure discipline, and conduct discussions during travel. The spacious interior allows students to travel comfortably, reducing fatigue and improving focus during on-site learning.'
    },
    {
      title: 'Family Nature Outings',
      description: 'Families visiting Nighoj enjoy the convenience of traveling together in one vehicle. Elders benefit from comfortable seating, while children enjoy the group journey. The Tempo Traveller allows families to carry picnic supplies, extra clothing, and safety gear without space concerns. Shared travel strengthens family bonding and keeps the trip relaxed and well-coordinated.'
    },
    {
      title: 'Corporate Team Outings & Nature Breaks',
      description: 'Corporate teams often choose Nighoj for short nature breaks and team bonding. Traveling in a Tempo Traveller supports team interaction, informal discussions, and stress-free logistics. The comfortable ride ensures employees arrive refreshed and ready to explore, making the outing both productive and enjoyable.'
    },
    {
      title: 'Photography & Nature Exploration Tours',
      description: 'Photographers and nature explorers prefer early departures and flexible schedules. Tempo Traveller rentals make it easier to plan sunrise or off-peak visits, transport equipment safely, and move as a group between viewpoints. The vehicle becomes a mobile base for gear management and rest.'
    },
    {
      title: 'Seasonal Monsoon Visits',
      description: 'During monsoon, Nighoj Potholes become even more dramatic. Safe group travel is essential due to slippery paths and changing water levels. A professional driver and reliable Tempo Traveller add safety and peace of mind for visitors during such conditions.'
    },
    {
      title: 'Weekend Getaways from Pune',
      description: 'Nighoj is a popular weekend getaway from Pune. A 17 seater Tempo Traveller is ideal for friends and extended families looking for a quick escape without the hassle of multiple cars, fuel planning, or navigation stress.'
    },
    {
      title: 'Eco-Friendly Group Travel',
      description: 'Choosing one Tempo Traveller instead of several smaller vehicles reduces environmental impact, supports sustainable tourism, and minimizes traffic in rural areas.'
    }
  ],

  services: [
    {
      name: '17 Seater Tempo Traveller Nighoj Potholes Bus Trip',
      description: 'Sanavi Travels provides dedicated 17 seater Tempo Traveller services for Nighoj Potholes bus trips, focusing on comfort, safety, and smooth travel across village and rural roads. Our Tempo Travellers feature spacious push-back seating, good ventilation or air-conditioning options, ample legroom, and luggage space. This service is ideal for families, student groups, corporate teams, and nature lovers who want a reliable and well-organized group journey. The experienced driver ensures safe navigation on uneven roads, timely pickups, and relaxed travel planning, making the entire trip enjoyable and stress-free.'
    },
    {
      name: 'AC 17 Seater Tempo Traveller Nighoj',
      description: 'AC Tempo Travellers maintain a comfortable interior temperature, especially useful during summer and long daytime travel. Passengers remain relaxed and fresh upon arrival, which is important for walking and exploration at Nighoj.'
    },
    {
      name: 'Non AC 17 Seater Tempo Traveller Nighoj',
      description: 'Non-AC Tempo Travellers offer a cost-effective solution for groups seeking reliable transport without compromising seating comfort or safety.'
    },
    {
      name: 'Luxury 17 Seater Tempo Traveller Nighoj',
      description: 'Luxury variants include premium interiors, better suspension, and enhanced comfort, suitable for corporate groups, VIP guests, and special outings.'
    },
    {
      name: 'Tempo Traveller for Family Nighoj',
      description: 'Family-focused services ensure smooth travel for all age groups, with careful driving, comfortable seating, and enough space for belongings.'
    },
    {
      name: 'Tempo Traveller for Corporate Nighoj',
      description: 'Corporate Tempo Traveller services support punctual schedules, professional travel standards, and organized team outings.'
    },
    {
      name: 'Tempo Traveller for Group Nighoj',
      description: 'Group travel becomes simpler when everyone travels together, improving coordination and overall enjoyment.'
    },
    {
      name: 'Affordable 17 Seater Tempo Traveller Nighoj',
      description: 'Sanavi Travels offers transparent and competitive pricing, making group trips budget-friendly without hidden costs.'
    },
    {
      name: 'Best Tempo Traveller Service Nighoj',
      description: 'Our reputation is built on well-maintained vehicles, trained drivers, and consistent customer satisfaction.'
    },
    {
      name: 'Tempo Traveller with Driver Nighoj',
      description: 'All bookings include licensed drivers familiar with Pune–Nighoj routes and rural driving conditions.'
    },
    {
      name: 'Tempo Traveller for Wedding Nighoj',
      description: 'Wedding-related travel and guest transport can be managed smoothly with a single spacious vehicle.'
    },
    {
      name: 'Tempo Traveller for Picnic Nighoj',
      description: 'Picnic groups enjoy relaxed travel, space for food supplies, and stress-free group movement.'
    },
    {
      name: 'Mini Bus on Rent Nighoj',
      description: 'For slightly larger groups, mini bus options are also available depending on requirement.'
    },
    {
      name: '17 Seater Tempo Traveller for Sightseeing Nighoj',
      description: 'Sightseeing-focused travel ensures comfortable pacing, safe stops, and coordinated exploration.'
    },
    {
      name: 'Tempo Traveller for Outstation Nighoj',
      description: 'Outstation-ready Tempo Travellers handle longer distances and return trips comfortably.'
    }
  ],

  tableData: [
    ['AC Tempo Traveller', 'Non AC Tempo Traveller'],
    ['Luxury Variant', 'Standard Variant'],
    ['Family Trip', 'Corporate Trip'],
    ['Student Tour', 'Nature Outing'],
    ['Affordable Plans', 'Premium Comfort']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Experienced Rural Route Drivers',
      WhyChoosedescription: 'Drivers are trained to handle village roads, uneven terrain, and seasonal conditions safely.'
    },
    {
      WhyChooseheading: 'Comfortable 17 Seater Vehicles',
      WhyChoosedescription: 'Spacious seating and good suspension reduce travel fatigue.'
    },
    {
      WhyChooseheading: 'Ideal for Group Safety',
      WhyChoosedescription: 'Group travel ensures better supervision and coordination at rocky sites.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear pricing without hidden charges helps easy planning.'
    },
    {
      WhyChooseheading: 'Well-Maintained Fleet',
      WhyChoosedescription: 'Regular servicing ensures reliability and safety.'
    },
    {
      WhyChooseheading: 'Flexible Pickup Options',
      WhyChoosedescription: 'Custom pickup points available from Pune and nearby areas.'
    },
    {
      WhyChooseheading: 'Suitable for Educational Tours',
      WhyChoosedescription: 'Designed to support learning-focused travel.'
    },
    {
      WhyChooseheading: '24/7 Customer Support',
      WhyChoosedescription: 'Assistance available before and during the journey.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide 17 seater Tempo Traveller for Nighoj Potholes?',
    answer: 'Yes, Sanavi Travels offers 17 seater Tempo Traveller services specifically suitable for Nighoj Potholes trips, including AC and Non-AC options.'
  },
  {
    question: 'Is this trip suitable for families?',
    answer: 'Yes, families often choose this service for safe, comfortable, and organized group travel.'
  },
  {
    question: 'Are drivers experienced with village roads?',
    answer: 'Yes, our drivers are familiar with rural routes and local conditions.'
  },
  {
    question: 'Is it suitable for student study tours?',
    answer: 'Yes, many schools and colleges book Tempo Travellers for educational visits to Nighoj.'
  },
  {
    question: 'Can we book for a corporate outing?',
    answer: 'Yes, corporate teams regularly use this service for short nature outings.'
  },
  {
    question: 'Is advance booking required?',
    answer: 'Advance booking is recommended, especially during weekends and monsoon season.'
  },
  {
    question: 'Are vehicles sanitized?',
    answer: 'Yes, all vehicles are cleaned and sanitized before every trip.'
  },
  {
    question: 'Can pickup points be customized?',
    answer: 'Yes, pickup locations can be customized based on group convenience.'
  },
  {
    question: 'Is the pricing affordable?',
    answer: 'Yes, we offer competitive and transparent pricing for group travel.'
  },
  {
    question: 'Is customer support available?',
    answer: 'Yes, 24/7 customer support is available for assistance.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshmukh',
    feedback: 'We booked a 17 seater Tempo Traveller for a family trip to Nighoj Potholes. The vehicle was very comfortable, the driver was knowledgeable about the route, and the entire journey felt safe and relaxed. Traveling together made the experience memorable, especially for elders and kids.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Our college arranged a study tour to Nighoj Potholes using Sanavi Travels. The Tempo Traveller was clean, spacious, and perfectly suited for rural travel. The driver was patient and professional, and the trip was managed very smoothly.',
    rating: 5
  }
];



































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Tempo Traveller Nighoj Potholes Bus Trip - Sanavi Travels",
  "description": "Sanavi Travels offers 17 seater Tempo Traveller services for Nighoj Potholes trips, including AC and Non-AC luxury options. Ideal for family outings, corporate travel, group trips, weddings, picnics, sightseeing, and outstation journeys with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | 17 Seater Tempo Traveller Nighoj Potholes Trip | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 17 seater Tempo Travellers for Nighoj Potholes trips with Sanavi Travels. AC & Non-AC luxury Tempo Travellers for family outings, corporate travel, group trips, weddings, picnics, sightseeing, and outstation journeys with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/304.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onesevanseatertempotravellernighojpotholes;